var map = {
	"./2022_10_24_mini_data_warehouse.md": [
		9636,
		636
	],
	"./2022_11_02_lessons_in_ml_ops.md": [
		3520,
		520
	],
	"./2023_07_11_net_zero.md": [
		3208,
		208
	],
	"./2024_01_02_gophercon_2023.md": [
		7837,
		837
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9951;
module.exports = webpackAsyncContext;